<template>
  <section class="gallery-section">
    <div class="gallery-container">
      <div class="section-header">
        <div class="section-eyebrow">Field details</div>
        <h2 class="section-title">现场与细节图库</h2>
      </div>

      <div class="compare-grid">
        <article class="compare-card" v-for="item in comparisons" :key="item.title">
          <div class="compare-head">
            <strong>{{ item.title }}</strong>
            <span>{{ item.desc }}</span>
          </div>
          <div class="compare-images">
            <div class="compare-pane">
              <ZoomableImage :src="getImage(item.before.src)" :alt="item.before.caption" fit="cover" />
              <span class="pane-label">处理前</span>
            </div>
            <div class="compare-pane">
              <ZoomableImage :src="getImage(item.after.src)" :alt="item.after.caption" fit="cover" />
              <span class="pane-label">处理后</span>
            </div>
          </div>
        </article>
      </div>

      <div class="gallery-grid">
        <figure
          v-for="item in images"
          :key="item.src"
          class="gallery-card"
          :class="[`span-${item.span || 1}`, { tall: item.tall }]"
        >
          <ZoomableImage :src="getImage(item.src)" :alt="item.caption" :fit="item.fit || 'cover'" />
          <figcaption>
            <strong>{{ item.title }}</strong>
            <span>{{ item.caption }}</span>
          </figcaption>
        </figure>
      </div>
    </div>
  </section>
</template>

<script>
import ZoomableImage from './ZoomableImage.vue';

export default {
  name: 'FieldGallerySection',
  components: {
    ZoomableImage
  },
  data() {
    return {
      images: [
        {
          title: '现场检测',
          caption: '雷尼绍检测组件与三脚架',
          src: 'renishaw-kit.jpg',
          span: 2
        },
        {
          title: '设备搬迁',
          caption: '大型设备吊装转运',
          src: 'relocation-lifting.jpg',
          tall: true
        },
        {
          title: '搬迁组织',
          caption: '搬迁作业前现场协调',
          src: 'relocation-team.jpg'
        },
        {
          title: '深度保养细节',
          caption: '伺服与传动区域污染状态',
          src: 'dirty-servo.jpg'
        },
        {
          title: '深度清洁',
          caption: '内部结构清理细节',
          src: 'deep-cleaning-detail.jpg'
        }
      ],
      comparisons: [
        {
          title: '导轨与丝杠区域清洁对比',
          desc: '同一部位清洁前后状态对照',
          before: {
            caption: '导轨与丝杠区域清洁前',
            src: 'rail-before.jpg'
          },
          after: {
            caption: '导轨与丝杠区域清洁后',
            src: 'rail-after.jpg'
          }
        },
        {
          title: '深度保养前后状态对比',
          desc: '积屑、油污集中区域处理效果',
          before: {
            caption: '深度保养前积屑与油污状态',
            src: 'dirty-case.jpg'
          },
          after: {
            caption: '深度保养后清洁状态',
            src: 'after-cleaning.jpg'
          }
        }
      ]
    };
  },
  methods: {
    getImage(src) {
      return require('@/assets/images/gallery/' + src);
    }
  }
};
</script>

<style scoped>
.gallery-section {
  background: #ffffff;
  padding: 88px 0;
}

.gallery-container {
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 24px;
}

.section-header {
  max-width: 860px;
  margin-bottom: 28px;
}

.section-eyebrow {
  color: #1976d2;
  font-size: 0.88rem;
  font-weight: 900;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.section-title {
  margin: 0 0 12px;
  color: #132033;
  font-size: 2.2rem;
  font-weight: 900;
  letter-spacing: 1px;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: 230px;
  gap: 14px;
}

.compare-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 18px;
}

.compare-card {
  margin: 0;
  border-radius: 22px;
  overflow: hidden;
  border: 1px solid #e8eef6;
  background: #ffffff;
  box-shadow: 0 14px 34px rgba(16, 35, 64, 0.06);
}

.compare-head {
  padding: 16px 18px 14px;
  border-bottom: 1px solid #e8eef6;
}

.compare-head strong,
.compare-head span {
  display: block;
}

.compare-head strong {
  color: #132033;
  font-size: 1.04rem;
  margin-bottom: 5px;
}

.compare-head span {
  color: #536173;
  line-height: 1.6;
  font-size: 0.92rem;
}

.compare-images {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1px;
  background: #e8eef6;
}

.compare-pane {
  position: relative;
  height: 260px;
  background: #f8fafc;
}

.pane-label {
  position: absolute;
  left: 10px;
  top: 10px;
  color: #ffffff;
  background: rgba(19, 32, 51, 0.72);
  border-radius: 999px;
  padding: 5px 10px;
  font-size: 0.82rem;
  font-weight: 800;
}

.gallery-card {
  position: relative;
  margin: 0;
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid #e8eef6;
  background: #f8fafc;
  box-shadow: 0 14px 34px rgba(16, 35, 64, 0.06);
}

.gallery-card.span-2 {
  grid-column: span 2;
}

.gallery-card.tall {
  grid-row: span 2;
}

.gallery-card figcaption {
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 12px;
  padding: 10px 12px;
  border-radius: 14px;
  color: #ffffff;
  background: linear-gradient(90deg, rgba(19, 32, 51, 0.86), rgba(19, 32, 51, 0.58));
  backdrop-filter: blur(8px);
}

.gallery-card figcaption strong,
.gallery-card figcaption span {
  display: block;
}

.gallery-card figcaption strong {
  font-size: 0.96rem;
  margin-bottom: 4px;
}

.gallery-card figcaption span {
  color: rgba(255, 255, 255, 0.84);
  line-height: 1.5;
  font-size: 0.86rem;
}

@media (max-width: 1024px) {
  .compare-grid {
    grid-template-columns: 1fr;
  }

  .gallery-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .gallery-section {
    padding: 60px 0;
  }

  .gallery-grid {
    grid-template-columns: 1fr;
    grid-auto-rows: 240px;
  }

  .compare-images {
    grid-template-columns: 1fr;
  }

  .compare-pane {
    height: 230px;
  }

  .gallery-card.span-2,
  .gallery-card.tall {
    grid-column: span 1;
    grid-row: span 1;
  }
}
</style>
